<template>
  <div class="xcard">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined> <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn>    
    <h3 class="text-center" style="margin-top:0">Notas de los estudiantes</h3>
    <p class="text-center text-primary">Nombre del modulo</p>

    <div class="table-responsive">
      <table class="table table-condensed table-focus">
        <thead>
          <tr>
            <th>Nro</th>
            <th>Estudiante</th>
            <th :key="inde" v-for="(m,inde) in modulos"> {{m}} </th>
            <th> Nota final </th>
          </tr>
        </thead>

        <tbody>
          <tr :key="ind" v-for="(e,ind) in estudiantes">
            <td> {{ind+1}} </td>
            <td> {{e.userfullname}} </td>
            <td :key="index" v-for="(n,index) in e.notas"> {{ n.not }} </td>
            <td> {{e.final}} </td>
          </tr>
        </tbody>
      </table>
    </div>

    <Alertas ref="alertar" />
  </div>
</template>

<script>
//import moodle_client from 'moodle-client'
import Alertas from '@/components/AAlertas.vue'

export default {
  data(){
    return{ 
      estudiantes: [],
      course_id: 0,
      modulos: [],
    }
  },
  components:{ Alertas },
  methods:{
    do_something( client ){
      var vue = this;
      // window.console.log( "COURSE ID: ",vue.course_id );
      return client.call({
        wsfunction: "gradereport_user_get_grade_items",
        args: {
          courseid: vue.course_id,
        }

      }).then(function(info) {
          vue.parsero( info );
          return;
      }).catch(function(err) {
        window.console.log("Error" + err);
        alert( "Ha ocurrido un error, intente nuevamente. \n\nAsegurese que el id de curso exista y existan calificaciones" )
        vue.$router.replace({name:'programaview'}); 
      });
    },
    parsero( info ){
      var vue = this;
      // window.console.log(info.usergrades[0].gradeitems );
        vue.estudiantes = info.usergrades;
        if( vue.estudiantes.length > 0 ){
          vue.estudiantes[0].gradeitems.forEach( function(e){
            var nombrecito = e.itemname;
            if( !nombrecito ) nombrecito = "SIN NOMBRE"
            vue.modulos.push( nombrecito );
          })
        }

        vue.estudiantes.forEach( function(e){
        e.notas = [];
        var final = 0;
        e.gradeitems.forEach( function(i){
          var nota = i.graderaw;
          e.notas.push( { nom:i.itemname,not:nota?nota:"-" } );
          if( nota ) final += nota;
        })
        e.final = final;

        vue.$refs.alertar.reset();
      })
    },
  },
  mounted(){
    /*var vue = this;
    var xp = JSON.parse( sessionStorage.xmod );
    this.course_id = xp.course_id;
    this.$refs.alertar.cargando();

    moodle_client.init({
      wwwroot: process.env.VUE_APP_DOMAIN_MOODLE,
      username: "rcoronadoaguilar",
      password: "Mod0.esam",
      strictSSL: false

    }).then(function(client) {
      vue.do_something( client );

    }).catch(function(err) {
      window.console.log("Unable to initialize the client: " + err);
    });*/

  }
}
</script>